/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelSupplementWorkflow200Response
 */
export interface CancelSupplementWorkflow200Response {
    /**
     * 
     * @type {string}
     * @memberof CancelSupplementWorkflow200Response
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelSupplementWorkflow200Response
     */
    workflowId?: string;
}

/**
 * Check if a given object implements the CancelSupplementWorkflow200Response interface.
 */
export function instanceOfCancelSupplementWorkflow200Response(value: object): value is CancelSupplementWorkflow200Response {
    return true;
}

export function CancelSupplementWorkflow200ResponseFromJSON(json: any): CancelSupplementWorkflow200Response {
    return CancelSupplementWorkflow200ResponseFromJSONTyped(json, false);
}

export function CancelSupplementWorkflow200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelSupplementWorkflow200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
    };
}

export function CancelSupplementWorkflow200ResponseToJSON(json: any): CancelSupplementWorkflow200Response {
    return CancelSupplementWorkflow200ResponseToJSONTyped(json, false);
}

export function CancelSupplementWorkflow200ResponseToJSONTyped(value?: CancelSupplementWorkflow200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'workflowId': value['workflowId'],
    };
}

